import { isDefined } from "@clipboard-health/util-ts";

import {
  BookabilityDecision,
  type BookabilityStatusItem,
  type BookabilityUnmetCriteria,
  type BookabilityUnmetCriteriaWithMetadata,
} from "./types";

type ExtractedBookabilityUnmetCriteriaWithMetadata<T extends BookabilityUnmetCriteria> = Extract<
  BookabilityUnmetCriteriaWithMetadata,
  { unmetCriteria: T }
>;

export function getUnmetCriteriaWithMetadata<T extends BookabilityUnmetCriteria>(params: {
  bookabilityStatus: BookabilityStatusItem | undefined;
  unmetCriteria: T;
}): ExtractedBookabilityUnmetCriteriaWithMetadata<T> | undefined {
  const { bookabilityStatus, unmetCriteria } = params;
  if (
    !isDefined(bookabilityStatus) ||
    bookabilityStatus.attributes.bookability.decision !== BookabilityDecision.BLOCKED
  ) {
    return undefined;
  }

  return bookabilityStatus.attributes.bookability.unmetCriteriaWithMetadata?.find(
    (criteria): criteria is ExtractedBookabilityUnmetCriteriaWithMetadata<T> =>
      criteria.unmetCriteria === unmetCriteria
  );
}
